export default __webpack_public_path__ + "static/media/2020.96f5530b.pdf";